import { PortalServico } from '@/utils'
import Alerta from './Alerta'
/**
 * @type {AlertaServico}
 */
export default class AlertaServico extends PortalServico {

    listarAlertasPendentes() {
        const self = this
        return self.get('/wsportal/alertas/listarAlertasPendentes')
                    .then(resultado => resultado.map(item => Alerta.buildFromJson(item)));
    }

    listarAlertasRecentes() {
        const self = this;
        return self.get('/wsportal/alertas/listarAlertasRecentes')
                   .then(resultado => resultado.map(item => Alerta.buildFromJson(item)));
    }

    baixarAlertaPortal(numseqale, nomsisale){
        const self = this;
        return self.post('/wsportal/alertas/baixarAlertaPortal',{
            numseqale,
            nomsisale
        }).then(resultado => Alerta.buildFromJson(resultado));
    }

    gravarLeituraAlerta(numseqale, nomsisale){
        const self = this
        return self.post('/wsportal/alertas/marcarAlertaVisualizado',{
            numseqale,
            nomsisale
        }).then(resultado => Alerta.buildFromJson(resultado));
    }

}